module.exports = __webpack_public_path__ + "static/img/banner.819ee9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advance/banner.png
// module id = HL55
// module chunks = 1